import React, { useEffect, useState } from "react";
import StyledForm from "../assets/StyledForm";
import SelectMenu from "../assets/SelectMenu";
import { useSelector } from "react-redux";
import en from "../../util/locales/en";
import ar from "../../util/locales/ar";
import { useForm } from "react-hook-form";
import BackButton from "./BackButton";
import YearMonthPicker from "./YearMonthPicker/YearMonthPicker";
import ksa from "../../images/flags/ksa.png";

const Form = ({
  onSubmit,
  formData,
  setFormData,
  fields,
  submitText = "Submit",
  back,
  showBackButton,
  isLoading,
  ...props
}) => {
  const checkIsMobile = () => window.innerWidth <= 768;
  const [isMobile, setIsMobile] = useState(checkIsMobile());
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;

  useEffect(() => {
    const onResize = () => {
      setIsMobile(checkIsMobile());
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [window.innerWidth]);

  function isArabic(text) {
    var pattern = /[\u0600-\u06FF\u0750-\u077F]/;
    let result = pattern.test(text);
    return result;
  }

  const {
    handleSubmit,
    register,
    formState: { errors },
    setError,
    setValue,
  } = useForm();

  const formSubmit = handleSubmit((data) => {
    onSubmit();
  });

  useEffect(() => {
    const keys = [
      "model",
      "year",
      "car_color",
      "interior_color",
      "interior_fabric",
      "seller",
    ];
    Object.keys(formData).map((key) => {
      if (keys.includes(key) && formData[key]) {
        setError(key, null);
      }
    });
  }, [formData]);

  console.log("formData date-picker: ", formData);

  return (
    <StyledForm
      onSubmit={(e) => {
        e.preventDefault();
        // onSubmit();
      }}
    >
      <div className="fields">
        {fields.map((field) =>
          field.type === "date-picker" ? (
            // New date picker field type
            <div
              className={`input-div ${field.name}-input-div`}
              key={field.name}
            >
              <p>
                {field.displayName}
                {field?.required !== false && (
                  <span
                    style={{
                      color: "#EB5757",
                    }}
                  >
                    *
                  </span>
                )}
              </p>
              <div className="date-picker-wrapper">
                <YearMonthPicker
                  value={formData[field.name]}
                  onChange={(date) => {
                    setFormData({
                      ...formData,
                      [field.name]: date,
                    });
                    setValue(field.name, date);
                    setError(field.name, null);
                  }}
                  placeholder={field.placeholder}
                  disabled={props.disabled || field.disabled}
                  language={language}
                  minDate={field.minDate}
                  maxDate={field.maxDate}
                />
                {/* Hidden input for form validation */}
                <input
                  type="hidden"
                  {...register(field.name, {
                    required: {
                      value: field.required !== false ? true : false,
                      message: "required",
                    },
                  })}
                  value={formData[field.name] ? formData[field.name] : ""}
                />
              </div>
              {errors[field.name]?.message && (
                <p className="error-text">
                  {language == "en"
                    ? `${field.displayName} is ${
                        t[errors[field.name]?.message]
                      }`
                    : `${t[errors[field.name]?.message]} ${field.displayName}`}
                </p>
              )}
            </div>
          ) : field.type === "select" && field.name != "code" ? (
            <div
              className={`input-div ${field.name}-input-div`}
              key={field.name}
            >
              {
                <p>
                  {field.displayName}
                  {field?.required !== false && (
                    <span
                      style={{
                        color: "#EB5757",
                      }}
                    >
                      *
                    </span>
                  )}
                </p>
              }
              <div className="select-menu">
                <SelectMenu
                  field={field}
                  disabled={props.disabled || field.disabled}
                  value={formData[field.name]}
                  setValue={(value) => {
                    setFormData({
                      ...formData,
                      [field.name]: value,
                    });
                    setError(field.name, null);
                  }}
                  getPaginationData={field.getPaginationData}
                  registerObj={{
                    ...register(field.name, {
                      required: {
                        value:
                          field.required === false
                            ? false
                            : formData[field.name]
                            ? false
                            : true,
                        message: "required",
                      },
                    }),
                  }}
                  search={field.search || null}
                  allowTyping={field.allowTyping || false}
                />
                {errors[field.name]?.message && (
                  <p className="error-text">
                    {language == "en"
                      ? `${field.displayName} is ${
                          t[errors[field.name]?.message]
                        }`
                      : `${t[errors[field.name]?.message]} ${
                          field.displayName
                        }`}
                  </p>
                )}
              </div>
            </div>
          ) : field.name == "phone" ? (
            <div className="input-div" key="mobile">
              <p>
                {t.mobileNumber}
                {field?.required !== false && (
                  <span style={{ color: "#EB5757" }}>*</span>
                )}
              </p>
              <div className="mobile-input-div">
                <div
                  className="phone-input-container"
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    className="country-code-prefix"
                    style={{
                      position: "absolute",
                      left: language === "ar" ? "auto" : "12px",
                      right: language === "ar" ? "12px" : "auto",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#333",
                      fontSize: "16px",
                      fontWeight: "500",
                      zIndex: 1,
                      pointerEvents: "none",
                    }}
                  >
                    <img src={ksa} alt="ksa" style={{ width: "20px" }} /> +966
                  </span>
                  <input
                    name="mobile"
                    placeholder={t.authPages.mobile}
                    type="text"
                    inputMode="numeric"
                    pattern="\d{9}" // Regex for exactly 9 digits
                    required
                    minLength={9}
                    maxLength={9}
                    onKeyDown={(e) => {
                      if (["e", "-", "+", "."].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    {...register("mobile", {
                      required: {
                        value: true,
                        message: "required",
                      },
                      pattern: {
                        value: /^\d{9}$/,
                        message: "invalidLength",
                      },
                      onChange: (e) => {
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 9);
                        setFormData((prev) => ({
                          ...prev,
                          mobile: value,
                        }));
                      },
                    })}
                    value={formData["mobile"] || ""}
                    style={{
                      paddingLeft: language === "ar" ? "12px" : "90px",
                      paddingRight: language === "ar" ? "90px" : "12px",
                      width: "100%",
                    }}
                  />
                </div>
              </div>

              {errors["mobile"]?.message && (
                <p className="error-text">
                  {errors["mobile"].message === "invalidLength"
                    ? language === "en"
                      ? `${t.carFinance.personalInfo.mobileNumber} must be 9 digits`
                      : `${t.carFinance.personalInfo.mobileNumber} يجب أن يكون 9 أرقام`
                    : language === "en"
                    ? `${t.carFinance.personalInfo.mobileNumber} is ${
                        t[errors["mobile"]?.message]
                      }`
                    : `${t[errors["mobile"]?.message]} ${
                        t.carFinance.personalInfo.mobileNumber
                      }`}
                </p>
              )}
            </div>
          ) : (
            <div className="input-div" key={field.name}>
              <p>
                {field.displayName}{" "}
                {field?.required !== false && (
                  <span
                    style={{
                      color: "#EB5757",
                    }}
                  >
                    *
                  </span>
                )}
              </p>
              {field.displayCurrency && <p className="currency">SAR</p>}
              <input
                name={field.name}
                placeholder={field.placeholder}
                type={"text"}
                inputmode={field.type == "number" && "numeric"}
                pattern={field.type == "number" && "[0-9]*"}
                required={field.required === false ? false : true}
                maxLength={field.name === "nationalId" ? 10 : undefined} // Added maxLength for nationalId
                minLength={10}
                onKeyDown={(e) => {
                  if (field.type == "number") {
                    if (e.key === "e" || e.key === "-") {
                      e.preventDefault();
                    }
                  }
                }}
                {...register(field.name, {
                  required: {
                    value: field.required === false ? false : true,
                    message: `required`,
                  },
                  validate: (value) => {
                    if (field.required !== false && field.type == "number") {
                      if (!isNaN(value) || formData[field.name]) {
                        return true;
                      } else return `required`;
                    }
                  },
                  maxLength:
                    field.name === "nationalId"
                      ? {
                          value: 10,
                          message: "invalidLength",
                        }
                      : undefined,
                  valueAsNumber: field.type == "number",
                  pattern:
                    field.name == "email"
                      ? {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: `invalid`,
                        }
                      : {},
                  onChange: (e) => {
                    let value =
                      field.type == "number"
                        ? e.target.value.replace(/\D/g, "")
                        : e.target.value;

                    // Limit nationalId to 10 digits
                    if (field.name === "nationalId") {
                      value = value.slice(0, 10);
                    }

                    setFormData({
                      ...formData,
                      [field.name]: value,
                    });
                  },
                })}
                style={
                  field.displayCurrency
                    ? language == "en"
                      ? {
                          paddingRight: !isMobile ? "3.819vw" : "13.333vw",
                        }
                      : {
                          paddingLeft: !isMobile ? "3.819vw" : "13.333vw",
                        }
                    : {}
                }
                value={formData[field.name] || ""}
                className={`${
                  isArabic(formData[field.name]) ? "arabic-input" : ""
                } ${!isNaN(+field.placeholder) ? "number-placeholder" : ""}`}
              />
              {errors[field.name]?.message && (
                <p className="error-text">
                  {errors[field.name]?.message === "invalidLength" &&
                  field.name === "nationalId"
                    ? language == "en"
                      ? `${field.displayName} must be 10 digits`
                      : `${field.displayName} يجب أن يكون 10 أرقام`
                    : errors[field.name]?.message != "invalid"
                    ? language == "en"
                      ? `${field.displayName} is ${
                          t[errors[field.name]?.message]
                        }`
                      : `${t[errors[field.name]?.message]} ${field.displayName}`
                    : language == "en"
                    ? `${t[errors[field.name]?.message]} ${field.displayName}`
                    : ` ${field.displayName} ${t[errors[field.name]?.message]}`}
                </p>
              )}
            </div>
          )
        )}
      </div>
      <div className="btn-container">
        {showBackButton && <BackButton onClick={back} />}
        <button
          className="submit"
          type="submit"
          onClick={formSubmit}
          disabled={isLoading}
          style={{
            opacity: isLoading ? "0.6" : "1",
            cursor: isLoading ? "not-allowed" : "pointer",
          }}
        >
          {submitText}
        </button>
      </div>
    </StyledForm>
  );
};

export default Form;
